import Vue from 'vue';
import moment from 'moment';

Vue.filter("formatDate", function (value) {
    if (value) {
        return moment(value).format("DD/MM/YYYY HH:mm");
    }
});

Vue.filter("formatDateY", function (value) {
    if (value) {
        return moment(value).format("DD/MM/YYYY");
    }
});

Vue.filter("formatDateMY", function (value) {
  if (value) {
    return moment(String(value)).format("MMMM YYYY");
  }
});

Vue.filter("formatHeure", function (value) {
  if (value) {
    return moment(String(value)).format("HH:mm");
  }
});

Vue.filter("formatUnixDateY", function (value) {
    if (value) {
        return moment(value).format("DD/MM/YYYY");
    }
});

Vue.filter("formatJour", function (value) {
  if (value) {
    if (
      moment(String(value)).format("dddd") ==
      moment(String(new Date())).format("dddd")
    )
      return "Aujourd'hui";
    return (
      moment(String(value))
        .format("dddd")
        .charAt(0)
        .toUpperCase() +
      moment(String(value))
        .format("dddd")
        .slice(1)
    );
  }
});

Vue.filter("capitalize", function (value) {
  if (!value) return "";

  const words = value.split(" ");

  let result = "";

  for (let i = 0; i < words.length; i++) {
    const word = words[i];
    result += word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() + " ";
  }

    return result;
});

Vue.filter("formatUnixFullDate", function (value) {
    if (value) {
        return moment(value, "x").format("DD MMMM YYYY");
    }
});

Vue.filter("formatUnixHeure", function (value) {
    if (value) {
        return moment(value, "x").format("HH:mm:ss");
    }
});

Vue.filter("formatUnixMinuteHour", function (value) {
  if (value) {
      return moment(value, "x").format("HH:mm");
  }
});

Vue.filter("ellipsis", function (value) {
  if (value) {
    return value.length > 80 ? `${value.substring(0, 80)}...` : value;
  }
});

Vue.filter("personName", function(value) {
  if (value) {
    return value.firstName + " " + value.lastName;
  }
});


Vue.filter("formatPhone", function(phoneNumber) {
  const delimiter = " ";
  const regexPattern = new RegExp(/\d{1,2}/, "g");
  if (phoneNumber) {
    phoneNumber = phoneNumber.toString().replace(/ /g, "");
    const plus = phoneNumber.includes('+')
    if (plus) {
      phoneNumber = phoneNumber.replace('+', '');
    }
    if (phoneNumber.length % 2 ) {
      const leftPart = phoneNumber.substring(0, 5);
      const rightPart = phoneNumber.substring(5);
      return (plus ? "+" : "") + leftPart.replace(/(\d\d)(\d\d\d)/, "$1 $2") + delimiter + rightPart.match(regexPattern).join(delimiter);
    } else {
      return /^\d+$/.test(phoneNumber) ? (plus ? "+" : "") + phoneNumber.match(regexPattern).join(delimiter) : '';
    }
  }
  return "";
});
